import { z } from "zod";
import { idSchema } from "./fields";

export const boatPhotoContentTypeSchema = z.enum([
  "image/jpeg",
  "image/png",
  "image/webp",
]);
export type BoatPhotoContentType = z.infer<typeof boatPhotoContentTypeSchema>;

export const MAX_BOAT_PHOTO_BYTES = 5 * 1024 * 1024;

/** Photo upload sent as base64 so it travels over the ordinary tRPC JSON transport. */
export const boatPhotoUploadSchema = z.object({
  boatId: idSchema,
  contentType: boatPhotoContentTypeSchema,
  // base64 inflates by 4/3; the decoded size is re-checked on the server.
  dataBase64: z
    .string()
    .min(1, "The photo is empty.")
    .max(
      Math.ceil((MAX_BOAT_PHOTO_BYTES * 4) / 3) + 4,
      "Photos must be 5 MB or smaller."
    ),
});
export type BoatPhotoUpload = z.infer<typeof boatPhotoUploadSchema>;

/** Where the browser loads a boat's photo; the version busts caches when the photo changes. */
export const boatPhotoUrl = (boatId: number, photoUpdatedAt: Date): string =>
  `/api/boats/${boatId}/photo?v=${photoUpdatedAt.getTime()}`;
